export const INVOICE_DETAILS_ATTEMPT = 'INVOICE_DETAILS_ATTEMPT';
export const INVOICE_DETAILS_SUCCESS = 'INVOICE_DETAILS_SUCCESS';
export const INVOICE_DETAILS_FAILURE = 'INVOICE_DETAILS_FAILURE';
export const INVOICE_DETAILS_CLEAR_STATE = 'INVOICE_DETAILS_CLEAR_STATE';
